import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

interface NextButtonProps {
	onClick?: () => void;
}

const NextButton = ({ onClick }: NextButtonProps = {}) => {
	return (
		<Button
			size="lg"
			type={onClick ? "button" : "submit"}
			onClick={onClick}
			data-testid="next-button"
			className="group flex justify-center items-center gap-2 w-full transition-all duration-300"
		>
			Next
			<ArrowRight className="w-4 h-4 transition-all group-hover:translate-x-1 duration-300 ease-in-out" />
		</Button>
	);
};

export default NextButton;
